// extracted by mini-css-extract-plugin
export default {"container":"Header_container__I-ZOl","scrolled":"Header_scrolled__wFF6o","logoContainer":"Header_logoContainer__-jtfp"};